module.exports = __webpack_public_path__ + "assets/img/note-text.875532df.svg";